import { reactive, ref, watchEffect } from "vue";
import createAuth0Client from "@auth0/auth0-spa-js";
import jwt_decode from "jwt-decode";

const DEFAULT_REDIRECT_CALLBACK = () =>
  window.history.replaceState({}, document.title, window.location.pathname);

let instance;

export const getInstance = () => instance;

export const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}) => {
  if (instance) return instance;

  const state = reactive({
    loading: true,
    isAuthenticated: false,
    user: null,
    auth0Client: null,
    popupOpen: false,
    error: null,
  });

  const methods = {
    async loginWithPopup(o) {
      state.popupOpen = true;
      try {
        await state.auth0Client.loginWithPopup(o);
      } catch (e) {
        state.error = e;
      } finally {
        state.popupOpen = false;
      }
      state.user = await state.auth0Client.getUser();
      state.isAuthenticated = true;
    },

    async handleRedirectCallback() {
      state.loading = true;
      try {
        console.log(state.auth0Client.getUser(),"user");
        
        await state.auth0Client.handleRedirectCallback();
        state.user = await state.auth0Client.getUser();
        state.isAuthenticated = true;
      } catch (e) {
        state.error = e;
      } finally {
        state.loading = false;
      }
    },

    loginWithRedirect(o) {
      return state.auth0Client.loginWithRedirect(o);
    },

    getIdTokenClaims(o) {
      return state.auth0Client.getIdTokenClaims(o);
    },

    async getAuthTokenClaims() {
      const token = await state.auth0Client.getTokenSilently();
      return jwt_decode(token).permissions;
    },

    getTokenSilently(o) {
      return state.auth0Client.getTokenSilently(o);
    },

    getTokenWithPopup(o) {
      return state.auth0Client.getTokenWithPopup(o);
    },

    logout(o) {
      return state.auth0Client.logout(o);
    },

    async getUserRole() {
      const claims = await state.auth0Client.getIdTokenClaims();
      return claims["skittles://roles"] || [];
    },

    async getUserRoles() {
      const claims = await state.auth0Client.getIdTokenClaims();
      return claims[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ] || [];
    },
  };

  const initAuth0 = async () => {
    state.auth0Client = await createAuth0Client({
      domain: options.domain,
      client_id: options.clientId,
      audience: options.audience,
      redirect_uri: redirectUri,
    });

    try {
      if (window.location.search.includes("code=") && window.location.search.includes("state=")) {
        const { appState } = await state.auth0Client.handleRedirectCallback();
        onRedirectCallback(appState);
      }
    } catch (e) {
      state.error = e;
    } finally {
      state.isAuthenticated = await state.auth0Client.isAuthenticated();
      state.user = await state.auth0Client.getUser();
      state.loading = false;
    }
  };

  initAuth0();

  instance = { state, ...methods };

  return instance;
};

// Vue 3 Plugin Setup
export const Auth0Plugin = {
  install(app, options) {
    const auth0 = useAuth0(options);
    app.provide('auth', auth0);
  },
};
